module.exports = __webpack_public_path__ + "static/media/mysql.efd22267.png";